// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "dc57cd6f1d03b4a39b69b62742b9c4cfc1e8c737/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};